import { SvgIcon, SvgIconProps } from '@mui/material';

const OpenIcon = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="white"
  >
    <path d="M19 37.8889C29.432 37.8889 37.8889 29.432 37.8889 19C37.8889 8.56793 29.432 0.111084 19 0.111084C8.56793 0.111084 0.111084 8.56793 0.111084 19C0.111084 29.432 8.56793 37.8889 19 37.8889Z" />
    <g transform="translate(10 11)" fill="white">
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="white"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z"
          fill="white"
        />
      </svg>
    </g>
  </SvgIcon>
);

export default OpenIcon;
